import { Collapse, CollapseProps } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { COLOR_SET_LIST_TASK } from '../../const';
import { getKeyCollapse } from '../../functions';
import { RootState } from '../../store';
import { ItemTaskType, ItemType, MappingItemIdIndexType } from '../../types';
import DrawerPanelTask from './drawerPanelTask';

const StyledCollapse = styled(Collapse).withConfig({
    shouldForwardProp: (prop) => prop !== 'bgColor',
})<{ bgColor?: string }>`
    &.ant-collapse > div > .ant-collapse-header {
        background-color: ${(props) => props.bgColor || '#f0f0f0'};
    }
    &.ant-collapse > div.ant-collapse-item > .ant-collapse-header[aria-expanded='false'] {
        margin-bottom: 5px;
    }
    &&.ant-collapse > div.ant-collapse-item .ant-collapse-content-box {
        padding-bottom: 0;
    }
`;

interface IDrawerPanelGroupTask {
    childrenIdList: string[];
    listTaskForShow: ItemTaskType[];
    levelGroup: number;
    listItemIdForShow: Set<string>;
}

const DrawerPanelGroupTask: React.FC<IDrawerPanelGroupTask> = ({
    childrenIdList,
    listTaskForShow,
    levelGroup,
    listItemIdForShow,
}) => {
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>((state) => state.gant.mappingItemIdIndex);
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);

    const collapseScheduleItem: CollapseProps['items'] = childrenIdList.map((childId) => {
        const childItem = itemsList[mappingItemIdIndex[childId]];

        const childrenCollapseAndTask = [];

        if (childItem?.tasks?.length) {
            childrenCollapseAndTask.push(
                ...listTaskForShow
                    .filter((task) => task.schedule_item_id === childId)
                    .map((task) => <DrawerPanelTask key={task.id} task={task} />),
            );
        }

        const childrenCollapse = childItem?.children ? (
            <DrawerPanelGroupTask
                key={childId}
                childrenIdList={childItem?.children.filter((itemId) => listItemIdForShow.has(itemId))}
                listItemIdForShow={listItemIdForShow}
                listTaskForShow={listTaskForShow}
                levelGroup={levelGroup + 1}
            />
        ) : null;

        if (childrenCollapse) {
            childrenCollapseAndTask.push(childrenCollapse);
        }

        return {
            key: childId,
            label: childItem?.name,
            children: childrenCollapseAndTask,
            forceRender: true,
        };
    });

    return collapseScheduleItem.length ? (
        <div style={{ paddingLeft: 10 }}>
            <StyledCollapse
                className={`collapse_level_${levelGroup}`}
                defaultActiveKey={getKeyCollapse(collapseScheduleItem)}
                ghost
                bgColor={COLOR_SET_LIST_TASK[levelGroup]}
                items={collapseScheduleItem}
                expandIconPosition={'end'}
            />
        </div>
    ) : null;
};

export default DrawerPanelGroupTask;
